import { combineReducers } from 'redux';
import home from './home';
import weightLoss from './weight_loss';
import weightLossSurgeonMatch from './weight_loss_surgeon_match';
import partners from './partners';
import getStarted from './get_started';
import getStartedV2 from './get_started_v2';

export default combineReducers({
  home,
  weightLoss,
  weightLossSurgeonMatch,
  partners,
  getStarted,
  getStartedV2,
});
